import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Volume2, VolumeX, Shuffle } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { subscribeAudio, toggleMuteSong } from "../lib/profileSong";

const iconBtn = "flex h-9 w-9 flex-none items-center justify-center rounded-[var(--card-radius)] border border-[var(--border-subtle)] text-[var(--text-primary)] transition-colors hover:border-[var(--accent)] hover:text-[var(--accent-hover)]";

// The single, global mute for every skin sound (profile song + wheel clicks).
export function MuteToggle({ className = "" }) {
  const [muted, setMuted] = useState(false);
  useEffect(() => subscribeAudio((st) => setMuted(st.muted)), []);
  const label = muted ? "Unmute sounds" : "Mute sounds";
  return (
    <button type="button" onClick={() => toggleMuteSong()} title={label} aria-label={label} aria-pressed={muted}
      data-audio-control="true" data-testid="nav-mute-toggle" data-muted={muted ? "true" : "false"} className={`${iconBtn} ${className}`}>
      {muted ? <VolumeX size={17} /> : <Volume2 size={17} />}
    </button>
  );
}

let lastPick = "";

// Picks one random title from THIS account's Favorites (heart list) and opens it.
export function useShuffle() {
  const navigate = useNavigate();
  return async () => {
    try {
      const { data } = await api.get(`/favorites/shuffle?exclude=${encodeURIComponent(lastPick)}`);
      if (!data.id) {
        toast("Add some favorites first", { description: "Tap the heart on any title, then shuffle picks one for you.", action: { label: "Favorites", onClick: () => navigate("/favorites") } });
        return;
      }
      lastPick = data.id;
      navigate(`/title/${data.id}`);
    } catch { toast.error("Couldn't shuffle right now"); }
  };
}

export function ShuffleButton({ className = "" }) {
  const shuffle = useShuffle();
  return (
    <button type="button" onClick={shuffle} title="Shuffle a favorite" aria-label="Shuffle a favorite" data-testid="nav-shuffle-button" className={`${iconBtn} ${className}`}>
      <Shuffle size={17} />
    </button>
  );
}
